import { MoveLooseItems } from './MoveLooseItems';

export default MoveLooseItems;
